"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateExpiredDate = void 0;
var IsDocumentSafe_1 = __importDefault(require("./IsDocumentSafe"));
var convertMinutesToMilliseconds = function (minutes) { return minutes * 60 * 1000; };
var calculateExpiredDate = function (expireInMinutes) {
    var expireInSecondsFromEpoch = new Date().setTime(new Date().getTime() + convertMinutesToMilliseconds(expireInMinutes));
    var expireDate = new Date(expireInSecondsFromEpoch);
    return expireDate ? "; expires=" + expireDate.toUTCString() : '';
};
exports.calculateExpiredDate = calculateExpiredDate;
var Cookies = {
    get: function (name) {
        if (!IsDocumentSafe_1.default()) {
            return null;
        }
        var regexp = new RegExp("(?:^" + name + "|; *" + name + ")=(.*?)(?:;|$)", 'g');
        var result = regexp.exec(document.cookie);
        return result === null ? null : result[1];
    },
    set: function (name, value, expireInMinutes) {
        if (!IsDocumentSafe_1.default()) {
            return;
        }
        var expires = exports.calculateExpiredDate(expireInMinutes);
        document.cookie = name + "=" + value + expires + "; path=/";
    }
};
exports.default = Cookies;
